module.exports = __webpack_public_path__ + "static/media/2@1024w.acb2d0bf.jpg";